import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { importDetergent } from '@/apis/detergents'
import routes from '@/constants/routes'
import useNotification from '@/hooks/useNotification'
import { ImportCsvRequest, ImportCsvResponse } from '@/types'

export const useImportDetergent = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<ImportCsvResponse>()

  const imp = useCallback(
    async (request: ImportCsvRequest) => {
      try {
        setLoading(true)
        const res = await importDetergent(request)
        setResponse(res)
        openNotification({ type: 'success', description: t('components.pages.admins.common.import.success') })
        navigate(routes.detergents.path)
      } catch (error) {
        openNotification({ type: 'error', description: t('components.pages.admins.common.import.fail') })
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  return {
    loading,
    importCsvDetergent: imp,
    response,
  }
}
